import { render, staticRenderFns } from "./measureList.vue?vue&type=template&id=31b0e781&scoped=true&"
import script from "./measureList.vue?vue&type=script&lang=js&"
export * from "./measureList.vue?vue&type=script&lang=js&"
import style0 from "./measureList.vue?vue&type=style&index=0&id=31b0e781&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0e781",
  null
  
)

export default component.exports